import r from "../managers/braze-instance.js";
import { validateStandardString as ir } from "../util/validation-utils.js";
export function setSdkAuthenticationSignature(t) {
  if (!r.rr()) return !1;
  if ("" === t || !ir(t, "set signature", "signature", !1)) return !1;
  var i = r.Sr();
  return !!i && (i.setSdkAuthenticationSignature(t), !0);
}